// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".card_box[data-v-6b140c5c] {\n  width: 100%;\n}", ""]);
// Exports
module.exports = exports;
